import React from "react";
import loader from "./Assets/Rainbow.gif";
const Loader = () => <img src={loader} alt="Loader" />;
export default Loader;